import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = { auth: true }

export default {
	path: '/exchangeOrder',
	name: 'exchangeOrder',
	meta,
	redirect: {
		name: 'exchangeOrder'
	},
	component: layoutHeaderAside,
	children: (pre => [
		{
			path: 'exchangeOrderDeliveryPlan',
			name: `${pre}exchangeOrderDeliveryPlan`,
			component: _import('order/exchangeOrderDeliveryPlan'),
			meta: {
				...meta,
				title: '配送计划管理',
			}
		},
		{
			path: 'exchangeOrderDeliverySummary',
			name: `${pre}exchangeOrderDeliverySummary`,
			component: _import('order/exchangeOrderDeliverySummary'),
			meta: {
				...meta,
				title: '配送订单统计',
			}
		},
	])('exchangeOrder-')
}